import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from 'src/app/pages/admin/auth/login/login.component';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(
    private scroller: ViewportScroller,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
  }
  openModal() {
    this.modalService.open(LoginComponent, { centered: true });
  }
}
